// Public Honolulu SEO guide pages — used for cross-linking and the homepage links.
export const HONOLULU_GUIDES = [
  { path: "/honolulu-first-date-ideas", label: "Safe first date ideas in Honolulu" },
  { path: "/meet-singles-honolulu", label: "How to meet singles in Honolulu" },
  { path: "/first-date-safety-tips", label: "First date safety tips" },
];
